<!--
  cfntChnChngPrctr.vue ( redirect-1, mblElcSgn13 )
  - 대면 채널로 변경된 가계약
  - 유입 
     1. ctrBasMttCnf ( 계약정보조회 )
     2. acntSgnInp ( 계좌서명입력 )
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <!--Header [s]-->
    <Header :rtrnAnimInsYn="state.rtrnAnimInsYn" />
    <!--Header [e]-->
    <!-- Container [s] -->
    <div class="container type_complete">
      <!-- 완료페이지만 : type_complete 클래스 적용 -->
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <div class="finish_wrap">
            <p>
              대면 채널으로 변경된 가계약 입니다.<br /><span
                >이용해주셔서 감사합니다.</span
              >
            </p>
          </div>
          <div class="btn_area">
            <button type="button" class="btn_main" @click="goHome">
              <span>확인</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer :rtrnAnimInsYn="state.rtrnAnimInsYn" />
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "cfntChnChngPrctr",
  components: {
    Header,
    Footer,
  },
  setup() {
    const router = useRouter();

    var state = reactive({
      rtrnAnimInsYn: false,
      mode: process.env.NODE_ENV,
    });

    const goHome = () => {
      let url = "";
      if (state.mode == "development") {
        url = "https://mdev.meritzfire.com:16541/main.do";
      } else {
        url = "https://m.meritzfire.com/main.do";
      }
      location.href = url;
    };

    return {
      state,
      goHome,
    };
  },
};
</script>